import React, { Fragment, useEffect } from 'react';
import styles from 'styles/button_select.module.scss';
import useBindToContext from 'hooks/useBindToContext';
	import { Button, Icon, Switch, CustomButton } from 'components';
import classNames from 'lib/classNames';
import { SideBarBadge } from './Sidebar';

const ButtonSelect = ({
	options,
	onChange,
	value,
	BindToContext,
	onSelect = null,
	loading = [],
	showSeparator = true,
	showCheckedIcon = true,
	inlineIcon = false,
	noIconBG,
	className,
	isVertical,
	disabledClick = false,
	shopContext,
	keyPrefix = "",
	buttons
}) => {
	const [BindedValue, BindedOnChange, _, onRender] = useBindToContext(BindToContext, value, onChange);

	//useEffect(() => {
	//if (onRender?.length) onRender.forEach(fn => fn());
	//}, [onRender]);

	return (
		<div
			className={`${classNames('flex items-stretch w-full', {
				'flex-col': isVertical,
			})} ${className || ''}`}
		>
			{options.map((option, i) => {
				const isLoading = loading[i] ? loading[i] : false;
				const isLastButton = i === options.length - 1;
				const selected = BindedValue === option.value;
				const isDisabled =  option.disabled
				return (
					<Fragment key={keyPrefix + i}>
						<div
							className={classNames(
								'relative flex flex-col flex-1 text-gray-500 rounded bg-white p-2 border-2 focus:outline-none hover:shadow',
								{
									'border-blue-500': selected,
									'border-gray-500': !selected,
									'justify-start': !!option.info,
									'justify-center': !option.info,
									'cursor-pointer focus:ring': !isDisabled,
									'opacity-50 cursor-not-allowed': !!isDisabled,
								}
							)}
							onClick={() => {
								if (isDisabled || option.disabledClick) return;
								if(BindToContext) BindedOnChange(option.value);
								if (onSelect) onSelect(option.value);
							}}
							onKeyPress={(event) => {
								if (event.key === 'Enter' && !isDisabled) {
									if(BindToContext) BindedOnChange(option.value);
									if (onSelect) onSelect(option.value);
								}
							}}
							tabIndex="0"
						>
							{selected && showCheckedIcon && (
								<div className={classNames('clear-both')}>
									<div
										className={classNames('rounded-full flex-center', {
											'w-8 h-8 float-right mb-1': !!option.icon && !inlineIcon,
											'w-5 h-5 absolute top-1/2 transform -translate-y-1/2 right-0 mr-1':
												!option.icon || inlineIcon,
											'bg-blue-500 text-white': !noIconBG,
											'text-blue-500': noIconBG,
										})}
									>
										<Icon
											spin={!!option.loading}
											size="sm"
											icon={
												option.loading
													? 'spinner-third'
													: noIconBG && !!option.icon
														? option.icon
														: 'check'
											}
										/>
									</div>
								</div>
							)}
							{!selected && !!option.icon && (
								<div className={classNames('clear-both')}>
									<div
										className={classNames('rounded-full flex-center', {
											'w-8 h-8 float-right mb-1': !inlineIcon,
											'w-6 h-6 absolute top-1/2 transform -translate-y-1/2 right-0 mr-2': inlineIcon,
											'bg-gray-500 text-white': !noIconBG,
											'text-gray-500': noIconBG,
										})}
									>
										<Icon
											spin={!!option.loading}
											icon={option.loading ? 'spinner-third' : option.icon}
										/>
									</div>
								</div>
							)}
							<h3
								className={classNames('capitalize font-bold text-sm relative', {
									'text-left mb-1': !!option.info,
									'text-center': !option.info,
									'text-blue-500': selected,
									'text-gray-600': !selected,
									'flex items-center justify-between': option.withSwitch,
								})}
							>
								{option.beta && <SideBarBadge className={classNames('flex-center bg-orange-500 transform -translate-y-full')} style={{ top: -2, right: -2 }}>Beta</SideBarBadge>}
								{option.label}
								{option.withSwitch && (
									<div className={classNames('clear-both')}>
										<Switch BindToContext={BindToContext} />
									</div>
								)}
							</h3>
							{!!option.title && (
								<p className={classNames('text-gray-600 text-xs font-bold mb-2')}>{option.title}</p>
							)}
							{!!option.info && !option.infoHtml && (
								<p className={classNames('text-gray-500 text-xs italic h-full')}>{option.info}</p>
							)}
							{!!option.info && !!option.infoHtml && (
								<p
									className={classNames('text-gray-500 text-xs italic h-full')}
									dangerouslySetInnerHTML={{
										__html: option.info,
									}}
								/>
							)}
							{!!option.link && (
								<div
									className={classNames('text-gray-600 text-xs font-semibold underline mt-2 cursor-pointer')}
									onClick={() => window.open(option.link.href,"_blank")}
								>
									{option.link.text}
								</div>
							)}
							{ buttons  && buttons[option.value] && selected &&
								<div className={styles.innerButton}>
									<div 
										className={styles.button }
										onClick={buttons[option.value].onClick}	
									>
										{buttons[option.value].text} 
									</div>
								</div>
							}
						</div>
						{!isLastButton && showSeparator && <Or isVertical={isVertical} />}
						{!isLastButton && !showSeparator && <span className={classNames('mx-2')}></span>}
					</Fragment>
				);
			})}
		</div>
	);
};

const Or = ({ isVertical }) => (
	<div
		className={classNames(
			'flex justify-center items-center',
			isVertical ? 'flex-row w-3/4 my-2 mx-auto' : 'flex-col h-16 mx-2 my-auto'
		)}
	>
		<div
			style={{ width: !isVertical && 2, height: isVertical && 2 }}
			className={classNames('bg-gray-400 flex-1')}
		/>
		<span className={classNames('text-gray-600 font-bold uppercase', { 'mx-2': isVertical })}>or</span>
		<div
			style={{ width: !isVertical && 2, height: isVertical && 2 }}
			className={classNames('bg-gray-400 flex-1')}
		/>
	</div>
);
export default ButtonSelect;
